import request from './request'

export function listUnitConversion(data) {
  return request.post('/mes/unit-conversions/list', data)
}
export function selectUnitConversion() {
  return request.get('/mes/unit-conversions/select')
}
export function getUnitConversion(id) {
  return request.get('/mes/unit-conversions/' + id)
}
export function saveUnitConversion(data) {
  return request.post('/mes/unit-conversions', data)
}
export function updateUnitConversion(data) {
  return request.post('/mes/unit-conversions/update', data)
}
export function deleteUnitConversion(ids) {
  return request.post('/mes/unit-conversions/delete', ids)
}
export function convertUnit(data) {
  return request.post('/mes/unit-conversions/convert', data)
}
